"use client";

import { useTranslations } from "next-intl";
import { useEffect, useState } from "react";

import { LocalePreference } from "@/components/profile/preferences/LanguagePreference";
import { ThemePreference } from "@/components/profile/preferences/ThemePreference";
import { Card, CardContent } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { Skeleton } from "@/components/ui/skeleton";
import { Typography } from "@/components/ui/typography";

export const Preferences = () => {
    const t = useTranslations("profile");

    const [ mounted, setMounted ] = useState(false);

    useEffect(() => setMounted(true), []);

    return (
        <div className="flex flex-col gap-6 md:hidden">
            <Typography variant="h3">{t("preferences")}</Typography>
            <Card className="bg-accent">
                <CardContent className="p-4">
                    {!mounted ? (
                        <>
                            <Skeleton className="h-[52px] w-full" />
                            <Separator className="my-2" />
                            <Skeleton className="h-[52px] w-full" />
                        </>
                    ) : (
                        <>
                            <LocalePreference />
                            <Separator className="my-2" />
                            <ThemePreference />
                        </>
                    )}
                </CardContent>
            </Card>
        </div>
    );
};
